<template>
  <div class="mb-4">
    <div class="d-flex justify-content-between align-items-start">
      <div>
        <h2 class="mb-1">
          <font-awesome-icon icon="receipt" class="me-2" />
          Neue {{documentLabel}} erstellen
        </h2>
        <p class="text-muted mb-0">Folge dem Wizard, um eine neue {{documentLabel}} zu erstellen</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject } from 'vue'
import { ReceiptWizardSymbol } from '../tokens'

const wizard = inject(ReceiptWizardSymbol)

if (!wizard) {
  throw new Error('WizardHeader requires ReceiptWizard context')
}

const documentLabel = wizard.documentLabel
</script>
